import dataV from '@jiaminghi/data-view';
import Vue from 'vue';
import App from './App.vue';
import echarts from './plugins/echarts.js';
import router from './router';
import { get, post, put, del } from './utils/request'

import './styles/reset.css';

Vue.use(dataV);

Vue.prototype.$echarts = echarts;
Vue.prototype.$http = {
  get,
  post,
  put,
  del
}

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
